import { GetListResponse, instance } from "libs/api";

import { AuditLogResponse, AuditLogsRequestParams } from "../../auditLog.types";
import { ApiRoutesAuditLog } from "../../constants";

export const requestGetAuditLogs = async (
  params: AuditLogsRequestParams
): Promise<GetListResponse<AuditLogResponse>> => {
  return await instance.get(ApiRoutesAuditLog.AuditLogs, { params });
};
